import React from "react";
import { string } from "prop-types";

import "./section-paragraph.m.css";

const SectionParagraph = ({ children, ...props }) => {
  return (
    <p styleName="section-paragraph" {...props}>
      {children}
    </p>
  );
};

SectionParagraph.propTypes = {
  children: string.isRequired
};

export default SectionParagraph;